import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { Environment } from "@environments";
import { Observable, of, share } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CanActivateView implements CanActivateView
{
  constructor(@Inject(PLATFORM_ID) private platformId,
    private router: Router) { }

  public canActivate(): Observable<boolean>
  {
    if (isPlatformBrowser(this.platformId))
    {
      const isSiteEnabled: boolean = !Environment.isMaintenance;

      if (!isSiteEnabled)
      {
        this.router.navigate(['/maintenance']);
        return of(isSiteEnabled);
      }

      return of(true);
    }
  }
}
